import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = 'dbm_admin_token';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEY);
      if (!window.location.pathname.endsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => localStorage.setItem(STORAGE_KEY, t);
export const clearToken = () => localStorage.removeItem(STORAGE_KEY);
export const getToken = () => localStorage.getItem(STORAGE_KEY);

// Auth
export const login = (email, password) =>
  client.post('/auth/login', { email, password }).then((r) => r.data);
export const getMe = () => client.get('/auth/me').then((r) => r.data);

// Admin data
export const listEnquiries = () => client.get('/admin/enquiries').then((r) => r.data);
export const enquiriesUnreadCount = () =>
  client.get('/admin/enquiries/unread-count').then((r) => r.data.count);
export const updateEnquiry = (id, handled) =>
  client.patch(`/admin/enquiries/${id}`, { handled }).then((r) => r.data);
export const listSubscribers = () => client.get('/admin/subscribers').then((r) => r.data);
export const listBlogs = () => client.get('/admin/blogs').then((r) => r.data);
export const listNews = () => client.get('/admin/news').then((r) => r.data);

export const createBlog = (data) => client.post('/admin/blogs', data).then((r) => r.data);
export const updateBlog = (id, data) => client.put(`/admin/blogs/${id}`, data).then((r) => r.data);
export const deleteBlog = (id) => client.delete(`/admin/blogs/${id}`).then((r) => r.data);

export const createNews = (data) => client.post('/admin/news', data).then((r) => r.data);
export const updateNews = (id, data) => client.put(`/admin/news/${id}`, data).then((r) => r.data);
export const deleteNews = (id) => client.delete(`/admin/news/${id}`).then((r) => r.data);

// Clients
export const listClients = () => client.get('/admin/clients').then((r) => r.data);
export const createClient = (data) => client.post('/admin/clients', data).then((r) => r.data);
export const updateClient = (id, data) => client.put(`/admin/clients/${id}`, data).then((r) => r.data);
export const deleteClient = (id) => client.delete(`/admin/clients/${id}`).then((r) => r.data);
export const reorderClients = (ids) => client.put('/admin/clients/reorder', { ids }).then((r) => r.data);
export const setFeaturedOrder = (ids) => client.put('/admin/clients/featured-order', { ids }).then((r) => r.data);
export const listTestimonials = () => client.get('/admin/testimonials').then((r) => r.data);
export const createTestimonial = (data) => client.post('/admin/testimonials', data).then((r) => r.data);
export const updateTestimonial = (id, data) => client.put(`/admin/testimonials/${id}`, data).then((r) => r.data);
export const deleteTestimonial = (id) => client.delete(`/admin/testimonials/${id}`).then((r) => r.data);
export const reorderTestimonials = (ids) => client.put('/admin/testimonials/reorder', { ids }).then((r) => r.data);
export const setClientFeatured = (id, featured) =>
  client.patch(`/admin/clients/${id}/featured`, { featured }).then((r) => r.data);

// Uploads
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return client
    .post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data);
};

export const generateImage = (payload) =>
  client.post('/admin/generate-image', payload, { timeout: 90000 }).then((r) => r.data);

// CSV download helpers (must use blob response + trigger file download)
async function downloadCsv(path, filename) {
  const res = await client.get(path, { responseType: 'blob' });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const exportEnquiries = () =>
  downloadCsv('/admin/enquiries/export', `dbm-enquiries-${todayStr()}.csv`);

export const exportSubscribers = () =>
  downloadCsv('/admin/subscribers/export', `dbm-subscribers-${todayStr()}.csv`);

function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
}
